import { ConfigProvider, Select } from "antd";
import Commonformlabel from "./CommonFormLabel";
import Commonformerror from "./CommonFormError";

interface props {
  value: any;
  onChange: (value: any) => void;
  options: any;
  labelname: string;
  size: any;
  className?: any;
  nolabel?: boolean;
  style: any;
  allowClear?: boolean;
  required?: boolean;
  error?: any;
  touched?: any;
  name?: string;
  mode?: any;
  disabled?: boolean;
  loading?: boolean;
  zIndex?: number;
}

function Commonselectfield({
  value,
  onChange,
  options,
  labelname,
  size = "middle" || "large" || "small",
  className,
  nolabel = false,
  style,
  allowClear = true,
  required = false,
  error,
  touched,
  name,
  mode = "",
  disabled = false,
  loading = false,
  zIndex = 1050,
}: props) {
  const keyname = name ? name : "";

  return (
    <>
      <ConfigProvider
        theme={{
          components: {
            Select: {
              zIndexPopup: zIndex,
            },
          },
        }}
      >
        <div className="w-100">
          {nolabel ? (
            ""
          ) : (
            <Commonformlabel labelname={labelname} required={required} />
          )}

          <Select
            placeholder={`Select ${labelname}`}
            value={value}
            onChange={onChange}
            style={style}
            options={options}
            size={size}
            allowClear={allowClear}
            className={className}
            mode={mode}
            disabled={disabled}
            loading={loading}
            showSearch={true}
          />

          <Commonformerror
            required={required}
            touched={touched}
            name={keyname}
            error={error}
          />
        </div>
      </ConfigProvider>
    </>
  );
}

export default Commonselectfield;
